import type { ListOpsAuditQuery, ListOpsAuditResponse } from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

/**
 * Typed wrapper around `GET /v1/ops/audit`.
 *
 * The ops-api route is role-gated on `ops-admin`; unauthorized callers
 * surface 403 FORBIDDEN which `opsApiRequest` throws as `OpsApiError`.
 */

const BASE_PATH = '/v1/ops/audit';

function buildQueryString(query: ListOpsAuditQuery): string {
  const params = new URLSearchParams();
  if (query.action !== undefined && query.action.length > 0) {
    params.set('action', query.action);
  }
  if (query.target_type !== undefined && query.target_type.length > 0) {
    params.set('target_type', query.target_type);
  }
  if (query.target_id !== undefined && query.target_id.length > 0) {
    params.set('target_id', query.target_id);
  }
  if (query.ops_user_id !== undefined && query.ops_user_id.length > 0) {
    params.set('ops_user_id', query.ops_user_id);
  }
  if (query.limit !== undefined) {
    params.set('limit', query.limit.toString());
  }
  if (query.offset !== undefined) {
    params.set('offset', query.offset.toString());
  }
  const s = params.toString();
  return s.length > 0 ? `?${s}` : '';
}

export async function listOpsAudit(
  query: ListOpsAuditQuery,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListOpsAuditResponse> {
  const qs = buildQueryString(query);
  return opsApiRequest<ListOpsAuditResponse>(
    `${BASE_PATH}${qs}`,
    { signal },
    fetchImpl,
  );
}
